export default __webpack_public_path__ + "2257b8dd4443a0b352cad3028729023e.svg";